import { render } from "./BaseInfo.vue?vue&type=template&id=24b65dc2&scoped=true"
import script from "./BaseInfo.vue?vue&type=script&lang=js"
export * from "./BaseInfo.vue?vue&type=script&lang=js"

import "./BaseInfo.vue?vue&type=style&index=0&id=24b65dc2&lang=scss&scoped=true"
import "./BaseInfo.vue?vue&type=style&index=1&id=24b65dc2&lang=scss"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b65dc2"]])

export default __exports__